<template>
  <div>
    <div style="padding-bottom: 32px">
      <Title text="数据概览" />
    </div>
    <SectionCards />
    <div style="padding: 24px 0 32px 0">
      <Title text="我的业绩" />
    </div>
    <SectionAchieve />
  </div>
</template>

<script>
import Title from '@/components/Title';
import SectionCards from './components/SectionCards';
import SectionAchieve from './components/SectionAchieve';

export default {
  name: 'AchieveReport',
  components: {
    Title,
    SectionCards,
    SectionAchieve,
  },
};
</script>
